import styled from "styled-components";

export const OptInTextContentDefaultBox = styled.div`
    font-size: 1.4rem;
    margin-top: 4px;
    color: #CCCCCC;
    margin: 0px 24px;
    text-align: center;
`;